import { render, staticRenderFns } from "./PlanLanding.vue?vue&type=template&id=53a4448a"
import script from "./PlanLanding.vue?vue&type=script&lang=js"
export * from "./PlanLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports